/* eslint-disable */
/**
 * Select the order concrete delivery by status
 * @param {any} statusId The status id
 * @returns {Function} The selector function to return the data by statusId
 */
const orderConcreteDeliveriesStatus = (statusId) => (state) => state.orders[statusId] || null;

export default orderConcreteDeliveriesStatus;
